import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseFieldDataSourceControl } from '@d-components/base-field-control/base-data-source-control';
import { BaseLabelComponent } from '@d-components/label/label.component';
import { TranslateModule } from '@ngx-translate/core';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
@Component({
  selector: 'app-base-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    BaseLabelComponent,
    TranslateModule,
    ProgressSpinnerModule,
    TooltipModule,
  ],
})
export class BaseDropdownComponent
  extends BaseFieldDataSourceControl
  implements OnInit
{
  @Input() placeholder: string = 'Select';
  @Input() searchable!: boolean;
  @Output() onItemSelected: EventEmitter<any> = new EventEmitter();
  @Input() defaultValue: any = null;
  @Input() showClear: boolean = false;
  @Input() containerClass = '';

  @ViewChild('dropdown') dropdown!: Dropdown;
  selectedName: string = '';
  filterChange = new Subject<string>();
  overlayWidth = 0;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.sortOptions();

    this.selectedName = this.getLabelByValue(
      this.fieldControl.value || this.defaultValue,
    );

    if (this.searchable === undefined) {
      this.searchable = this.options.length > 5;
    }

    if (this.virtualScroll) {
      this.filterChange
        .pipe(debounceTime(400), distinctUntilChanged())
        .subscribe((value) => {
          this.currentEvent.searchBy = value;
          this.getOptions('searchChange');
        });
    }
  }

  ngAfterViewInit() {
    this.override();
  }

  onChange(event: any) {
    this.selectedName = this.getLabelByValue(event.value);
    this.onItemSelected.emit(event.value);
  }

  getLabelByValue(dropdownValue: any) {
    const t =
      this.options?.find(
        (i) => JSON.stringify(i.value) === JSON.stringify(dropdownValue),
      )?.label || '';
    return t;
  }

  onLazyLoad(event: { first: number; last: number }) {
    if (
      event.last > 0 &&
      event.last + 5 > this.options.length &&
      this.options.length < this.totalRecords &&
      !this.lazyLoading
    ) {
      this.getOptions('changePageIndex');
    }
  }

  private override() {
    const _this = this;

    const filterFunc = this.dropdown.activateFilter;

    this.dropdown.activateFilter = function () {
      if (!_this.virtualScroll) {
        filterFunc.call(this);
      }
    };
  }
  onShow(event: any) {
    let element = event.element as HTMLElement;
    element.style.width = this.overlayWidth + 'px';
  }

  onClick(event: any) {
    let element = <HTMLElement>event.target.closest('p-dropdown');
    this.overlayWidth = element.offsetWidth;
  }
}
